import { render, staticRenderFns } from "./MobileIndex.vue?vue&type=template&id=e3969634"
import script from "./MobileIndex.vue?vue&type=script&lang=js"
export * from "./MobileIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports